/**
 * Styled pieces of the quote modal. `QuoteName`, `ProductArea`, `ProductDetailSection` and
 * `ProductDetailItem` are used by `QuoteModalDesktop.tsx`; the `*Mobile` ones by
 * `QuoteModalMobile.tsx`.
 */
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Flex, FlexItem } from "@ryerson/frontend.layout";
import { Input } from "@ryerson/frontend.form-controls";

/** The desktop quote-name input. */
export const QuoteName = styled(Input)`
	margin-top: 20px;
`;

/** Wrapper of the desktop line list. */
export const ProductArea = styled.div`
	width: 100%;
`;

/** Three-column grid of a cut line's product attributes ("Cut From"), desktop. */
export const ProductDetailSection = styled.div`
	display: grid;
	grid-gap: 30px;
	grid-template-columns: 1fr 1fr 1fr;
	margin-bottom: 20px;
`;

/** One attribute (name over value) in {@link ProductDetailSection}. */
export const ProductDetailItem = styled.span`
	white-space: nowrap;
	display: block;
	break-inside: avoid-column;
`;

/** Panel holding a cut line's attributes on mobile; background from the `bgColor` prop. */
export const ProductDetailSectionMobile = styled(FlexItem)`
	padding: 0px 20px;
	border-radius: 2px;
	${(props: any) => {
		const { bgColor } = props;
		return css`
			background: ${bgColor};
		`;
	}};
`;

/** One attribute row on mobile, divided from the next by a `borderColor` line. */
export const ProductDetailsMobileItem = styled(FlexItem)`
	${(props: any) => {
		const { borderColor } = props;
		return css`
			&:not(:last-child) {
				border-bottom: 1px solid ${borderColor};
			}
		`;
	}};
`;

/** Name-and-value layout inside {@link ProductDetailsMobileItem}. */
export const ProductDetailMobile = styled(Flex)`
	padding: 10px 0px;
`;
